import Box from "@mui/material/Box";

const toColumnTemplate = (count) =>
  `repeat(${Math.max(1, Number(count) || 1)}, minmax(0, 1fr))`;

const BREAKPOINTS = ["xs", "sm", "md", "lg", "xl"];

const toGridColumns = (columns) => {
  if (typeof columns === "number") return toColumnTemplate(columns);

  let previous = columns?.xs || 1;
  return BREAKPOINTS.reduce((acc, key) => {
    previous = columns?.[key] || previous;
    acc[key] = toColumnTemplate(previous);
    return acc;
  }, {});
};

/**
 * Row-major layout that keeps submit order left to right. Drop-in replacement
 * for Masonry (installed lab alpha.94 has no sequential mode).
 */
const SequentialGrid = ({ columns, children }) => (
  <Box
    sx={{
      display: "grid",
      gap: 2,
      alignItems: "start",
      gridTemplateColumns: toGridColumns(columns),
    }}
  >
    {children}
  </Box>
);

export default SequentialGrid;
